import { put, takeLatest, take } from 'redux-saga/effects';

import { webServicesUtil, constants } from 'cloak-file-sdk-web';

import { SETTINGS_IMPORT_PARTNER_KEYCERT, SETTINGS_IMPORT_KEY, SETTINGS_EXPORT_KEY, SETTINGS_CHANGE_PASSWORD, SHOW_SETTINGS, SETTINGS_CLEAR_CACHE, SETTINGS_REVOKE_KEY, SETTINGS_IN_PROCESS } from '../reducers/settingsReducer'

const EXPORT_KEY = 'EXPORT_KEY'
const IMPORT_KEY = 'IMPORT_KEY'
const IMPORT_PARTNER_KEYCERT = 'IMPORT_PARTNER_KEYCERT'
const SHOW_MODAL_DIALOG = 'SHOW_MODAL_DIALOG'
const FILE_EXPORTED = 'FILE_EXPORTED'
const FILE_IMPORTED = 'FILE_IMPORTED'
const FILE_IMPORT_CANCELLED = 'FILE_IMPORT_CANCELLED'
const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
const PASSWORD_CHANGED = 'PASSWORD_CHANGED'
const REVOKE_CERT = 'REVOKE_CERT'
const CERT_REVOKED = 'CERT_REVOKED'
const PARTNER_KEYCERT_IMPORTED = 'PARTNER_KEYCERT_IMPORTED'
const PARTNER_KEYCERT_IMPORT_CANCELLED = 'PARTNER_KEYCERT_IMPORT_CANCELLED'

export function* exportKey() {

	let user = webServicesUtil().getAuth().username

	/* yield put({ type: SHOW_MODAL_DIALOG, payload: { showModalDialog : true, message: null } }) */

	var certStr = window.localStorage.getItem( constants.CLK_CERT + user )

	if (!certStr || certStr.length === 0) {
		console.log("In exportKey certStr error")
		yield put({ type : SETTINGS_IN_PROCESS, payload : { show: true, msg: 'settings.certExportError'} })
		return
	}
	//console.log("certStr " + certStr)
	var cert_data = JSON.parse(certStr)
	console.log("cert_data %o", cert_data)

	if (!cert_data || cert_data.userId !== user) {
		console.log("In exportKey cert_data error")
		yield put({ type : SETTINGS_IN_PROCESS, payload : { show: true, msg: 'settings.certExportError'} })
		return
	}

	yield put({ type : EXPORT_KEY, payload : { data : certStr, filename : constants.EXPORT_KEY_FILE_PREFIX + user + constants.EXPORT_KEY_FILE_EXT} })

	yield take(FILE_EXPORTED)

	yield put({ type : SHOW_SETTINGS, payload : true })

	//yield put({ type : SETTINGS_IN_PROCESS, payload : { show: true, msg: 'settings.certExported'} })
}

export function* importKey() {

	yield put({ type: SHOW_MODAL_DIALOG, payload: { showModalDialog : true, message: null } })

	yield put({ type : IMPORT_KEY })

	//yield take( FILE_IMPORTED )
}

export function* importPartnerKeyCert() {

	yield put({ type: SHOW_MODAL_DIALOG, payload: { showModalDialog : true, message: null } })

	yield put({ type : IMPORT_PARTNER_KEYCERT })
}

function* keyImportedHandler({ payload: { success } }) {
	console.log("In settingSaga keyImportedHandler success " + success)

	if (success) {
		yield put({ type : SETTINGS_IN_PROCESS, payload : { show: true, msg: 'settings.certImported'} })
	} else {
		yield put({ type : SETTINGS_IN_PROCESS, payload : { show: true, msg: 'settings.certImportError'} })
	}
}

function* keyImportCancelled() {
	console.log("In settingSaga keyImportCancelled")
	yield put({ type : SHOW_SETTINGS, payload : true })
}

function* partnerKeyCertImportedHandler({ payload: { success } }) {
	console.log("In settingSaga partnerKeyCertImportedHandler success " + success)
	yield put({ type : SHOW_SETTINGS, payload : true })

	if (success) {
		yield put({ type : SETTINGS_IN_PROCESS, payload : { show: true, msg: 'settings.partnerKeyCertImported'} })
	} else {
		yield put({ type : SETTINGS_IN_PROCESS, payload : { show: true, msg: 'settings.partnerKeyCertImportError'} })
	}
}

function* partnerKeyCertImportCancelled() {
	console.log("In settingSaga partnerKeyCertImportCancelled")
	yield put({ type : SHOW_SETTINGS, payload : true })
}

export function* changePassword() {

	console.log("In changePassword of settingSaga")

	yield put({ type : CHANGE_PASSWORD })

	yield take( PASSWORD_CHANGED )

	yield put({ type : SHOW_SETTINGS, payload : true })

}

export function* revokeKey() {

	console.log("In revokeKey of settingSaga")

	yield put({ type : REVOKE_CERT })

	console.log("In revokeKey of settingSaga take CERT_REVOKED")
	yield take( CERT_REVOKED )

	console.log("In revokeKey of settingSaga show settings again")
	yield put({ type : SHOW_SETTINGS, payload : true })

}

export function* clearCache() {

	console.log("In settingsSaga, clearCache")
	let user = webServicesUtil().getAuth().username
	window.localStorage.removeItem( constants.CLK_CERT + user )
	window.localStorage.removeItem( constants.ENC_CLK_CERT + user )

	var arr = []; // Array to hold the keys
	// Iterate over localStorage and insert the keys that meet the condition into arr
	for (var i = 0; i < window.localStorage.length; i++){
	    if (window.localStorage.key(i).substring(0,constants.ENC_CLK_CERT.length) === constants.ENC_CLK_CERT) {
	        arr.push(localStorage.key(i));
	    }
	}

	// Iterate over arr and remove the items by key
	for (var j = 0; j < arr.length; j++) {
	    window.localStorage.removeItem(arr[j]);
	}

	//yield put({ type : SHOW_SETTINGS, payload : true })

	yield put({ type : SETTINGS_IN_PROCESS, payload : { show: true, msg: 'settings.cacheCleared'} })
}

export function* settingSaga() {
	yield takeLatest( SETTINGS_IMPORT_KEY, importKey )
	yield takeLatest( SETTINGS_EXPORT_KEY, exportKey )
	yield takeLatest( SETTINGS_CHANGE_PASSWORD, changePassword )
	yield takeLatest( SETTINGS_REVOKE_KEY, revokeKey )
	yield takeLatest( SETTINGS_CLEAR_CACHE, clearCache )
	yield takeLatest( FILE_IMPORTED, keyImportedHandler )
	yield takeLatest( FILE_IMPORT_CANCELLED, keyImportCancelled )
	yield takeLatest( SETTINGS_IMPORT_PARTNER_KEYCERT, importPartnerKeyCert )
	yield takeLatest( PARTNER_KEYCERT_IMPORTED, partnerKeyCertImportedHandler )
	yield takeLatest( PARTNER_KEYCERT_IMPORT_CANCELLED, partnerKeyCertImportCancelled )
}
